import { takeEvery } from 'redux-saga/effects';

import { sagaApiGenWithPromise } from 'utils/sagaApiGeneratorHelpers';

import { dashboardActions } from '../actions/dashboard';
import {
  getAgentQueues,
  getAgentQueuesV1,
  getAllQueues,
  getAllQueuesV1,
  getQueuesById,
} from '../api/dashboard';

export const {
  dashboardGetAllQueues,
  dashboardGetAllQueuesSucceeded,
  dashboardGetAllQueuesFailed,
  dashboardGetAgentQueues,
  dashboardGetAgentQueuesSucceeded,
  dashboardGetAgentQueuesFailed,

  dashboardGetQueuesById,
  dashboardGetQueuesByIdSucceeded,
  dashboardGetQueuesByIdFailed,

  dashboardGetAllQueuesV1,
  dashboardGetAllQueuesSucceededV1,
  dashboardGetAllQueuesFailedV1,
  dashboardGetAgentQueuesV1,
  dashboardGetAgentQueuesSucceededV1,
  dashboardGetAgentQueuesFailedV1,
} = dashboardActions;

export const dashboard = [
  takeEvery(
    dashboardGetAllQueues.toString(),
    sagaApiGenWithPromise(
      getAllQueues,
      dashboardGetAllQueuesSucceeded,
      dashboardGetAllQueuesFailed,
    ),
  ),

  takeEvery(
    dashboardGetAgentQueues.toString(),
    sagaApiGenWithPromise(
      getAgentQueues,
      dashboardGetAgentQueuesSucceeded,
      dashboardGetAgentQueuesFailed,
    ),
  ),

  takeEvery(
    dashboardGetQueuesById.toString(),
    sagaApiGenWithPromise(
      getQueuesById,
      dashboardGetQueuesByIdSucceeded,
      dashboardGetAgentQueuesFailed,
    ),
  ),

  // v1 API endpoint sagas
  takeEvery(
    dashboardGetAllQueuesV1.toString(),
    sagaApiGenWithPromise(
      getAllQueuesV1,
      dashboardGetAllQueuesSucceededV1,
      dashboardGetAllQueuesFailedV1,
    ),
  ),

  takeEvery(
    dashboardGetAgentQueuesV1.toString(),
    sagaApiGenWithPromise(
      getAgentQueuesV1,
      dashboardGetAgentQueuesSucceededV1,
      dashboardGetAgentQueuesFailedV1,
    ),
  ),
];
